"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Styled = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _core = require("@material-ui/core");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _theme = require("../theme");
var _templateObject; // @ts-nocheck
// Adding this ^ because we cannot alter
// Our theme.js right now as it is heavily
// Used by OperatorPortal
var palette = _theme.theme.palette,
  shape = _theme.theme.shape;
var Styled = (0, _styledComponents["default"])(_core.AccordionActions)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  div {\n    background: ", ";\n    border-bottom-left-radius: ", "px;\n    border-bottom-right-radius: ", "px;\n    color: ", ";\n  }\n"])), palette.secondary[700], shape.borderRadius, shape.borderRadius, palette.text.primary);
exports.Styled = Styled;